(function () {
  if (window.ffolKlaviyoSignupBound) return;
  window.ffolKlaviyoSignupBound = true;

  var COMPANY_ID = "SrGcfy";
  var LIST_ID = "SfBbuX";

  function trackEssay(email) {
    return fetch("https://a.klaviyo.com/client/events/?company_id=" + COMPANY_ID, {
      method: "POST",
      headers: {
        revision: "2024-10-15",
        "content-type": "application/vnd.api+json",
      },
      body: JSON.stringify({
        data: {
          type: "event",
          attributes: {
            metric: {
              data: {
                type: "metric",
                attributes: { name: "Requested Essay Sample" },
              },
            },
            profile: { data: { type: "profile", attributes: { email: email } } },
            properties: { source: "Free essay sample" },
          },
        },
      }),
    }).then(function (response) {
      if (!response.ok) throw new Error("event failed");
    });
  }

  function subscribe(email, source) {
    return fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=" + COMPANY_ID,
      {
        method: "POST",
        headers: {
          revision: "2024-10-15",
          "content-type": "application/vnd.api+json",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: "profile",
                  attributes: { email: email },
                },
              },
            },
            relationships: {
              list: { data: { type: "list", id: LIST_ID } },
            },
          },
        }),
      }
    ).then(function (response) {
      if (!response.ok) {
        throw new Error("signup failed");
      }
    });
  }

  window.ffolKlaviyoSubscribe = subscribe;

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.getAttribute || !form.getAttribute("data-klaviyo-signup")) {
      return;
    }
    if (form.getAttribute("data-klaviyo-sent") === "1") {
      return;
    }
    var field = form.querySelector("[data-klaviyo-email]");
    var email = field && field.value ? field.value.trim() : "";
    if (!email) {
      return;
    }
    event.preventDefault();
    var source = form.getAttribute("data-klaviyo-signup");
    var message = form.querySelector("[data-klaviyo-message]");
    var done = function () {
      if (form.getAttribute("data-klaviyo-continue") === "shopify") {
        form.setAttribute("data-klaviyo-sent", "1");
        form.submit();
        return;
      }
      if (message) {
        message.hidden = false;
        message.textContent =
          "You're in. The sample is on its way. If it does not arrive, email info@lawprepare.com.";
      }
      form.reset();
    };
    var fail = function () {
      if (form.getAttribute("data-klaviyo-continue") === "shopify") {
        form.setAttribute("data-klaviyo-sent", "1");
        form.submit();
        return;
      }
      if (message) {
        message.hidden = false;
        message.textContent =
          "That did not go through. Email info@lawprepare.com and we will send it.";
      }
    };
    var request = subscribe(email, source).then(function () {
      if (source === "Free essay sample") return trackEssay(email);
    });
    if (form.getAttribute("data-klaviyo-continue") === "shopify") {
      var timer = new Promise(function (resolve) {
        window.setTimeout(resolve, 4000);
      });
      Promise.race([
        request.catch(function () {
          return "failed";
        }),
        timer,
      ]).then(function (result) {
        if (result === "failed") fail();
        else done();
      });
      return;
    }
    request.then(done).catch(fail);
  });
})();
